import { useEffect } from 'react'
import { appWithTranslation } from 'next-i18next'
import '../styles/globals.scss'

import dayjs from 'dayjs'
import dayjsBE from 'dayjs/plugin/buddhistEra'

import shippopTheme from '../components/common/theme'
import { ThemeProvider } from '@material-ui/core'

import { Provider } from '../context'

import 'dayjs/locale/th'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import updateLocale from 'dayjs/plugin/updateLocale'

dayjs.extend(dayjsBE)
dayjs.extend(localizedFormat)
dayjs.extend(updateLocale)

dayjs.locale('th')
dayjs.updateLocale('th', {
  formats: {
    LL: 'D MMMM BBBB',
    LLL: 'D MMMM BBBB - H:mm น.',
    LT: 'H:mm น.',
  }
})
dayjs.updateLocale('en', {
  formats: {
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY - h:mm A',
    LT: 'h:mm A',
  }
})

function MyApp({ Component, pageProps }) {
  useEffect(() => {
    const jssStyles = document.querySelector('#jss-server-side')
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles)
    }
  }, [])

  return (
    <>
      <Provider>
        <ThemeProvider theme={shippopTheme}>
          <Component {...pageProps} />
        </ThemeProvider>
      </Provider>
    </>
  )
}

export default appWithTranslation(MyApp)
